import React from "react";

import classes from "./homepage.module.css";
import "../../Main.css";

import { Link } from "react-router-dom";

import scrollAndPageFlip from "../../Utils/PageFlipAndScrollTop";

import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import TypedInfo from "./TypedInfo";

class HomePage extends React.Component {
  render() {
    return (
      <div className={[classes.HomePage, "flex-content", "Page"].join(" ")}>
        <h1>
          {" "}
          Hello, I'm <span>Raja Rahul.</span> <br />
          <TypedInfo
            strings={[
              "I'm a Software Developer at IBM",
              "I'm a FullStack web developer"
              
            ]}
          />{" "}
        </h1>
        <div className={classes.Buttons}>
          <Link
            onClick={scrollAndPageFlip}
            to="/about"
            className={classes.RedBtn}
            href="/"
          >
            <span>Explore More</span>
            <ArrowForwardIcon />{" "}
          </Link>
          <a
            className={classes.RedBtn}
            href="https://rajarahul.com/"
            target="_blank"
          >
            <span>My Blog </span>
            <ArrowForwardIcon />{" "}
          </a>
        </div> 
      </div>
    );
  }
}
export default HomePage;
